import { createContext, useContext } from "react";
import type { WBEAuthAccount } from "../api/contracts/wbe-auth";

export type WBEAuthContextType = {
  account: WBEAuthAccount | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  loginWithSession: (account: WBEAuthAccount, expiresAt: string) => void;
  logout: () => Promise<void>;
};

export const WBEAuthContext = createContext<WBEAuthContextType | undefined>(
  undefined,
);

export const useWBEAuth = () => {
  const context = useContext(WBEAuthContext);
  if (!context)
    throw new Error("useWBEAuth must be used within WBEAuthProvider");
  return context;
};
